import { IconButton, styled } from '@mui/material';

export const StepperInputContainer = styled('div')(({ theme }) => ({
  width: '100%',

  '& .MuiInputBase-input': {
    textAlign: 'center',
  },

  '& .MuiInputBase-root': {
    padding: theme.spacing(0, 1),
  },
}));

export const StepperInputButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,

  svg: {
    width: 24,
    height: 24,
    color: theme.palette.text2,
  },
}));
